import BasicBlockSection from './basic-block-section';

export default BasicBlockSection;
